<script>
import apiEndpoints from "@/services/apiEndpoints";
import DatePicker from "vue2-datepicker";
import systemCode from "@/mixins/systemCode";
import reservationTime from "@/mixins/reservationTime";
import datetime from "@/mixins/datetime";
import { extend } from "vee-validate";
import moment from "moment";
import sweetAlert from "@/mixins/sweetAlert";

extend('start_before_end', {
  params: ['target'],
  validate(value, { target }) {
    return moment(new Date(value)).isBefore(new Date(target));
  },
  message: 'スケジュールの終了日が開始日より前の日付になっています。'
});

export default {
  components: {
    DatePicker
  },
  mixins: [systemCode,reservationTime, datetime, sweetAlert],
	props: {
    isEdit:{
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      car: {},
      carPredeterminedSchedules: {
        car_id: "",
        start_datetime: "",
        end_datetime: "",
        title: "",
        zz_car_predetermined_schedule_type_id: 1,
        contents: ""
      },
      startTime:"",
      endTime:"",
      carPredeterminedScheduleId: null,
      openFromDate: false,
      openToDate: false,
      btnDeleteText: this.$lang.button.delete,
      validErrors: '',
    };
  },
  created() {
  },
  methods: {
    async getData(){
      this.isLoading = true;
      const url = apiEndpoints.car_predetermined_schedules_detail(this.carPredeterminedScheduleId);
      const sendApiProject = await this.$http.get(url);
      const { status, data } = sendApiProject;
      if (status && data.result) {
        this.carPredeterminedSchedules = data.result;
        this.car = data.result.car;
      }
      this.isLoading = false;
    },
    async submit() {
      this.isLoading = true;
      this.validErrors = '';
      let url = this.carPredeterminedScheduleId
                ? apiEndpoints.car_predetermined_schedules_update(this.carPredeterminedScheduleId)
                :apiEndpoints.car_predetermined_schedules_create;
      this.carPredeterminedSchedules.start_datetime = this.carPredeterminedSchedules.start_datetime ?
        (this.carPredeterminedSchedules.start_datetime.substring(0, 10) + ' ' + this.startTime) : null;
      this.carPredeterminedSchedules.end_datetime = this.carPredeterminedSchedules.end_datetime ?
        (this.carPredeterminedSchedules.end_datetime.substring(0, 10) + ' ' + this.endTime) : null;
      console.log(this.carPredeterminedSchedules);
      const sendApiProject = await this.$http.post(
        url,
        this.carPredeterminedSchedules
      );
      const { status, data } = sendApiProject;
      if (status) {
        this.successToast("車両の予定を登録しました", false, 2000);
        this.$emit('closeModal');
        this.$bvModal.hide("register-schedule-car");
      }else {
        this.validErrors = data.errors;
      }
      this.isLoading = false;
    },
    closeModal() {
      this.$bvModal.hide("register-schedule-car");
    },
    async openModal(car, carPredeterminedScheduleId, date) {
      this.validErrors = '';
      if(carPredeterminedScheduleId) {
        this.carPredeterminedScheduleId = carPredeterminedScheduleId;
        await this.getData();
      }
      else {
        this.carPredeterminedScheduleId = null;
        this.car = car;
        this.carPredeterminedSchedules.car_id = car.id;
        this.carPredeterminedSchedules.start_datetime = date + " " + this.getStartTimeOfDay;
        this.carPredeterminedSchedules.end_datetime = this.addOrSubtractTimeFromDate(
          15,
          'minutes',
          'add',
          this.carPredeterminedSchedules.start_datetime,
          'YYYY-MM-DD hh:mm'
        );
        this.carPredeterminedSchedules.title="";
        this.carPredeterminedSchedules.zz_car_predetermined_schedule_type_id = 1;
        this.carPredeterminedSchedules.contents= "";
      }
      this.startTime = this.carPredeterminedSchedules.start_datetime.split(' ')[1]
      this.endTime = this.carPredeterminedSchedules.end_datetime.split(' ')[1];
      this.$nextTick(() => {
        this.$bvModal.show("register-schedule-car");
      });
    },
    handleChangeFromDate(value, type) {
      if (type === "minute") this.openFromDate = false;
    },
    handleChangeToDate(value, type) {
      if (type === "minute") this.openToDate = false;
    },
    disabledDateForEndDate: function (date) {
      return (
        date.setHours(0, 0, 0, 0) < new Date(this.carPredeterminedSchedules.start_datetime).setHours(0, 0, 0, 0)
      );
    },
    async handleDelete() {
      this.isLoading = true;
      let url = apiEndpoints.car_predetermined_schedules_delete(this.carPredeterminedScheduleId);
      const sendApiProject = await this.$http.delete(url);
      this.isLoading = false;
      const { status, data } = sendApiProject;
      if (status) {
        this.successToast("車両の予定を削除しました", false, 2000);
        this.$emit('closeModal');
        this.$bvModal.hide("register-schedule-car");
      } else {
        this.errorToast(data.message);
      }
    },
    isInputError(input) {
      if (!this.validErrors) return false;

      return !!this.validErrors[input];
    }
  },
  computed: {
    zz_car_predetermined_schedule_types() {
      return (
        this.$store.getters["options/options_tables"]
          .zz_car_predetermined_schedule_types ?? []
      );
    },
    getStartTimeOfDay(){
      return  this.findTimezoneStart()?.system_code_value
    },
    getEndTimeOfDay(){
      return  this.findTimezoneEnd()?.system_code_value
    }
  }
};
</script>

<template>
  <div class="mb-2 d-xl-flex">
    <!-- modal area -->
    <b-modal
      size="lg"
      id="register-schedule-car"
      centered
      title-class="font-18"
      hide-footer
      title="車両の予定追加"
    >
      <b-row class="mt-2">
        <b-overlay
          rounded
          opacity="0.6"
          spinner-small
          :show="isLoading"
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div class="d-flex mb-3 custom-input">
            <label for="nameCar">車両</label>
            <div class=" w-100">
              <b-form-input
                disabled
                :value="car.name"
                id="nameCar"
                class="fw-bold"
              />
            </div>
          </div>
          <div class="d-flex flex-wrap justify-content-between mb-3 col-gap-5">
            <div class=" d-flex custom-input col-md-4">
              <label for="typeReservationCar">予定追加種別</label>
              <b-form-select
                class="form-select form-select-md"
                id="typeReservationCar"
                v-model="
                  carPredeterminedSchedules.zz_car_predetermined_schedule_type_id
                "
                :disabled="!isEdit"
              >
                <b-form-select-option
                  v-for="item in zz_car_predetermined_schedule_types"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.car_predetermined_schedule_type }}
                </b-form-select-option>
              </b-form-select>
            </div>
            <div class="d-flex custom-input col-md-7">
              <label for="titleReservationCar">タイトル</label>
              <div class="input-control">
                <b-input
                  id="titleReservationCar"
                  :disabled="!isEdit"
                  v-model="carPredeterminedSchedules.title"
                />
                <div
                  v-if="isInputError('title')"
                >
                  <span class="text-danger">{{ validErrors["title"][0] }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-3 custom-input">
            <label>予定追加日時</label>
            <b-row>
              <b-col>
                  <div class="custom-datepicker">
                    <div class="input-control">
                      <date-picker
                        v-model="carPredeterminedSchedules.start_datetime"
                        lang="ja"
                        placeholder="YYYY-MM-DD"
                        format="YYYY-MM-DD"
                        value-type="format"
                        type="date"
                        :disabled="!isEdit"
                        :editable="false"
                      ></date-picker>
                    </div>
                  </div>
              </b-col>
              <b-col
                cols="1"
                class="split text-center d-flex align-items-center"
              >
                <span>～</span>
              </b-col>
              <b-col>
                  <div class="custom-datepicker">
                    <div class="input-control">
                      <date-picker
                        v-model="carPredeterminedSchedules.end_datetime"
                        lang="ja"
                        placeholder="YYYY-MM-DD"
                        format="YYYY-MM-DD"
                        type="date"
                        value-type="format"
                        :disabled="!isEdit"
                        :disabled-date="disabledDateForEndDate"
                        :editable="false"
                      ></date-picker>
                    </div>
                  </div>
              </b-col>
            </b-row>
          </div>
          <div class="mb-1 custom-input">
            <label></label>
            <b-row>
              <b-col>
                <div>
                  <date-picker
                    v-model="startTime"
                    type="time"
                    placeholder="HH:mm"
                    format="HH:mm"
                    value-type="HH:mm"
                    :clearable="false"
                    :editable="false"
                    :open.sync="openFromDate"
                    @change="handleChangeFromDate"
                  ></date-picker>
                </div>
              </b-col>
              <b-col
                cols="1"
                class="split text-center d-flex align-items-center"
              >
                <span>～</span>
              </b-col>
              <b-col>
                <div>
                  <date-picker
                    v-model="endTime"
                    type="time"
                    placeholder="HH:mm"
                    format="HH:mm"
                    value-type="HH:mm"
                    :clearable="false"
                    :editable="false"
                    :open.sync="openToDate"
                    @change="handleChangeToDate"
                  ></date-picker>
                </div>
              </b-col>
            </b-row>
          </div>
          <div
            v-if="isInputError('start_datetime')"
            class="custom-input mb-2"
          >
            <label></label>
            <span class="text-danger">{{ validErrors["start_datetime"][0] }}</span>
          </div>
          <div
            v-if="isInputError('end_datetime')"
            class="custom-input mb-2"
          >
            <label></label>
            <span class="text-danger">{{ validErrors["end_datetime"][0] }}</span>
          </div>
          <div class="comment d-flex custom-input mt-3">
            <label for="contentReservationCar">内容</label>
              <b-form-textarea
                rows="4"
                max-rows="6"
                v-model="carPredeterminedSchedules.contents"
              ></b-form-textarea>
          </div>
          <div class="d-flex justify-content-center mt-2 gap-2">
            <button
              v-if="isEdit"
              @click="submit"
              class="btn btn-primary"
            >
              登録
            </button>
            <b-button
              v-if="isEdit && carPredeterminedScheduleId"
              @click="handleDelete"
              class="btn-custom-red"
            >
              <i class="fas fa-eraser"></i> {{ btnDeleteText }}
            </b-button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
p.white-space-pre {
  margin-top: 3px;
  margin-bottom: 3px;
}
.custom-input {
  align-items: center;
}
.custom-input label {
  font-weight: 600;
  flex: 0 0 100px;
}
.col-gap-5 {
  column-gap: 3rem !important;
}
.comment ::v-deep .ck-editor__editable {
  min-height: 100px;
  max-height: 100px;
}
</style>
